package com.supergenerous.common.aml

import com.supergenerous.common.data.Dbo
import com.supergenerous.common.file.CloudFileDbo
import com.supergenerous.common.util.Timestamp
import kotlinx.serialization.Serializable

/**
 * [Dbo] corresponding to the [AmlCheckResult] class.
 *
 * @author Franco Sabadini (franco@supergenerous.com)
 */
@Serializable
public data class AmlCheckResultDbo(

    var success: Boolean? = null,

    var manualCheck: Boolean? = null,

    val files: List<CloudFileDbo>? = null,

    val timestamp: Timestamp? = null

) : Dbo<AmlCheckResult> {

    override fun toDto(): AmlCheckResult {
        return AmlCheckResult(isSuccess = success!!,
                              isManualCheck = manualCheck ?: false,
                              files = files?.map { it.toDto() } ?: listOf(),
                              timestamp = timestamp)
    }

}